<template>
  <div>
    <router-link
      :to="{
        name: 'branchDashboard',
        query: {
          branchId: data.id,
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : data.companyId,
        },
      }"
      class="btn dealers_btn"
      v-b-tooltip="branches == 1 ? { customClass: 'my-tooltip-class' } : {}"
      :title="data.detailsTip"
      ><i class="fa fa-eye primary-color"> </i
    ></router-link>

    <button
      class="btn dealers_btn ml-2"
      @click="unmapBranchFromGroup(data)"
      v-if="this.$route.query.groupId"
    >
      {{ $t('text.clickButtons.unmapFromGroup') }}
    </button>

    <router-link
      v-if="!$route.query.groupId && !$route.query.regionId"
      :to="{
        name: 'mail_receipt',
        query: { id: data.id, companyId: this.$route.query.companyId },
      }"
      class="btn dealers_btn"
      v-b-tooltip="branches == 1 ? { customClass: 'my-tooltip-class' } : {}"
      :title="data.mailRecipientTip"
      ><i class="fa fa-envelope primary-color" style="color: white"> </i
    ></router-link>

    <router-link
      v-if="!$route.query.groupId && !$route.query.regionId"
      :to="{
        name: 'targets',
        query: { id: data.id, companyId: this.$route.query.companyId },
      }"
      class="btn dealers_btn"
      v-b-tooltip="branches == 1 ? { customClass: 'my-tooltip-class' } : {}"
      :title="data.manageTargetsTip"
      ><i class="fa fa-bullseye primary-color" style="color: white"> </i
    ></router-link>
    <button
      v-if="!$route.query.groupId && !$route.query.regionId"
      :to="{ name: 'targets', query: { id: data.id } }"
      class="btn dealers_btn"
      v-b-tooltip="branches == 1 ? { customClass: 'my-tooltip-class' } : {}"
      :title="$t('text.clickButtons.maxCash')"
      @click="setAmount"
    >
      <i
        class="fa fa-money primary-color"
        aria-hidden="true"
        style="color: white"
      ></i>
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
      branches: null,
    };
  },
  mounted() {
    setTimeout(() => {
      this.getBranch();
    }, 500);
  },
  methods: {
    addEmail(branchId) {
      this.$eventHub.$emit("addEmail", branchId);
    },
    setAmount(branchId) {
      this.$eventHub.$emit("_setAmount", this.data.id);
    },
    getBranch() {
      this.branches = this.$store.getters.getBranchTable;
    },
    unmapBranchFromGroup(data) {
      // console.log("unmap from group");
      this.$eventHub.$emit("unmapBranchFromGroup", data);
    },
  },
};
</script>
